import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const B2B_ORDERS_API_PATH = '/api/b2b-orders';

const fetchOrders = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${B2B_ORDERS_API_PATH}`, { params });
  return response.data;
};

const getOrder = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${B2B_ORDERS_API_PATH}/${id}`);
  return response.data.data;
};

const createOrder = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_ORDERS_API_PATH}`, payload);
  return response.data.data;
};

const createOrderFromCheckout = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_ORDERS_API_PATH}/from-checkout`, payload);
  return response.data.data;
};

const updateOrder = async (id, payload) => {
  const response = await axios.put(`${API_BASE_URL}${B2B_ORDERS_API_PATH}/${id}`, payload);
  return response.data.data;
};

const updateOrderStatus = async (id, payload) => {
  const response = await axios.put(`${API_BASE_URL}${B2B_ORDERS_API_PATH}/${id}/status`, payload);
  return response.data.data;
};

const createInvoiceFromOrder = async (id, payload = {}) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_ORDERS_API_PATH}/${id}/invoices`, payload);
  return response.data.data;
};

const b2bOrderService = {
  fetchOrders,
  getOrder,
  createOrder,
  createOrderFromCheckout,
  updateOrder,
  updateOrderStatus,
  createInvoiceFromOrder,
};

export default b2bOrderService;
